import { action, intercept, makeObservable, observable } from 'mobx'
import { IValidationSchema, required, validationContext } from 'validx'
import { BusinessInfo } from '@taxfyle/api-internal/internal/business_profile_pb'
import {
  maxLength,
  mustBeInThePast,
  mustBeValidEin,
  mustBeValidTaxFormInputValue,
} from 'utils/validation-utils'

export default class BusinessInfoEditorViewModel {
  @observable businessName = ''

  @observable dateOfIncorporation = ''

  @observable employerIdentificationNumber = ''

  private schema: IValidationSchema<this> = {
    businessName: [
      required('Business name is required'),
      mustBeValidTaxFormInputValue(),
      maxLength(100, 'Business name must not exceed 100 characters'),
    ],
    dateOfIncorporation: [
      required('Date of incorporation is required'),
      mustBeInThePast('Date of incorporation must be in the past'),
    ],
    employerIdentificationNumber: [
      required('EIN is required'),
      mustBeValidEin(),
    ],
  }

  validation = validationContext(this)

  constructor() {
    makeObservable(this)

    intercept(this, (change) => {
      this.validation.clearErrors(String(change.name))
      return change
    })
  }

  @action.bound
  validate() {
    return this.validation.reset().validate(this.schema).isValid
  }

  @action
  reset(info?: BusinessInfo.AsObject) {
    this.businessName = info?.businessName ?? ''
    this.dateOfIncorporation = info?.dateOfIncorporation ?? ''
    this.employerIdentificationNumber = info?.employerIdentificationNumber ?? ''
    this.validation.reset()
  }

  toBusinessInfo(): BusinessInfo.AsObject {
    return {
      businessName: this.businessName,
      dateOfIncorporation: this.dateOfIncorporation,
      employerIdentificationNumber: this.employerIdentificationNumber,
    }
  }
}
